module.exports = __webpack_public_path__ + "img/hide-answer.1e893549.png";